import { render, staticRenderFns } from "./FriendSearchResult.vue?vue&type=template&id=0806ac32&scoped=true"
import script from "./FriendSearchResult.vue?vue&type=script&lang=js"
export * from "./FriendSearchResult.vue?vue&type=script&lang=js"
import style0 from "./FriendSearchResult.vue?vue&type=style&index=0&id=0806ac32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0806ac32",
  null
  
)

export default component.exports